const es = {
  lng_name: 'Español',
  item_id_does_not_exist: 'El artículo {{id}} no está en tu lista Kaltura o ha sido eliminado.',
  your_kaltura_item_list_is_empty: 'Tu lista Kaltura de artículos está vacía.',
  purchase: 'comprar',
  purchased: 'comprado',
  go_to: 'Ir a',
  login_signup: 'Iniciar sesión/Registrarse',
  logout: 'Cerrar sesión',
  please_wait: 'Por favor, espera...',
  thank_you_for_your_purchase: 'Gracias por tu compra',
  buy_more_channels: 'Comprar más canales',
  go_to_premium_content: 'Ir al contenido premium',
  go_to_purchased_channels: 'Ir a los canales comprados',
};

export default es;